<script setup lang="ts">
import Footer from '~/components/layout/Footer.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col bg-white">
    <!-- Header -->
    <header class="sticky top-0 z-50 bg-white border-b border-neutral-200">
      <div class="container mx-auto px-4 flex items-center justify-between h-16">
        <NuxtLink to="/pusat-bantuan" class="flex items-center gap-2">
          <img src="/favicon-96x96.png" class="size-8" alt="Rintisan Billing">
          <span class="text-base font-semibold text-neutral-800">Pusat Bantuan</span>
        </NuxtLink>
        <NuxtLink
          to="/dashboard"
          class="text-sm font-medium text-primary hover:text-primary/80 transition-colors"
        >
          Dashboard
        </NuxtLink>
      </div>
    </header>

    <main class="flex-1">
      <slot />
    </main>
    <Footer />
  </div>
</template>
